import { useEffect, useState } from "react";
import { Keyboard, Platform } from "react-native";

// TODO cleanup for RN-3061
export const useKeyboardVisibility = ({ iosOnly = false }: { iosOnly?: boolean } = {}) => {
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  useEffect(() => {
    if (iosOnly && Platform.OS !== "ios") {
      return;
    }
    const showSubscription = Keyboard.addListener(
      Platform.OS === "ios" ? "keyboardWillShow" : "keyboardDidShow",
      () => setKeyboardVisible(true),
    );
    const hideSubscription = Keyboard.addListener(
      Platform.OS === "ios" ? "keyboardWillHide" : "keyboardDidHide",
      () => setKeyboardVisible(false),
    );

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, [iosOnly]);

  return keyboardVisible;
};
